/**
 * DO NOT MANUAL MODIFY THIS FILE
 *
 * AUTO GENERATED
 */
import { Ref, SVGProps, forwardRef } from 'react';
import classNames from 'classnames';
import { ICON_CLASS } from '../../../utils/constants';
import * as Styled from '../Icon.styles';
const DepotBase = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#404040" width="1em" height="1em" ref={ref} {...props}><path fillRule="evenodd" clipRule="evenodd" d="M3 3.5a.5.5 0 0 1 .5-.5h17a.5.5 0 0 1 .5.5V4a.5.5 0 0 1-.5.5H18v3.152c1.102.288 1.846.62 2.318.882.463.257.682.764.682 1.294V20a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9.828c0-.53.219-1.037.682-1.294C4.154 8.27 4.898 7.94 6 7.652V4.5H3.5A.5.5 0 0 1 3 4v-.5Zm3 6.231c-.422.131-.752.262-1 .376V19h1V9.731ZM7.5 19h3.75V9.008c-1.546.035-2.78.177-3.75.359V19Zm3.75-11.992a26.15 26.15 0 0 0-3.75.328V4.5h3.75v2.508Zm1.5 2V19h3.75V9.367c-.97-.182-2.204-.324-3.75-.359Zm3.75-1.672a26.15 26.15 0 0 0-3.75-.328V4.5h3.75v2.836ZM18 9.73V19h1v-8.893a8.259 8.259 0 0 0-1-.376Z" /></svg>);
const Depot = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(({
  className,
  ...rest
}: SVGProps<SVGSVGElement> & {
  className?: string;
}, ref) => <Styled.Icon className={classNames(ICON_CLASS, className)} as={DepotBase} {...rest} ref={ref} />);
export default Depot;